module.exports = __webpack_public_path__ + "img/BOWTIE 3 PURPLE.971c1cd.svg";